export const TOOLBAR_SELECTORS = {
   TOOLBAR_CONTAINER: '#toolbarContainer',
   TOOLBAR: '#toolbar',
   HIDDEN_TOOLBAR: '#hiddenToolbar',
   SHOW_MORE_BUTTON_GROUP: '#showMoreButtonGroup',
   TOOLBAR_BUTTON_GROUP: '.btn-group.me-2:not(#showMoreButtonsContainer), .dropdown.me-2',
} as const;